import { Injectable } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';
import { EPermission } from '../enums/permission.enum';

@Injectable({
  providedIn: 'root',
})
export class PrivilegeService {
  private privilegeResolvers: { [key in EPermission]: () => Promise<boolean> } = {
    [EPermission.ManageUsers]: () => this.isAdmin(),
    [EPermission.ManageTenants]: async () => this.isAdmin(),
    [EPermission.AnonymizePatients]: async () => this.isAdmin(),
    [EPermission.ReopenConsults]: async () => this.isAdmin(),
    [EPermission.ManageAnnouncements]: async () => this.isAdmin(),
    [EPermission.CurateHelpFeedback]: async () => this.isAdmin(),
  };

  public async hasPermission(permission: EPermission): Promise<boolean> {
    if (!this.privilegeResolvers[permission]) {
      return false;
    }

    return await this.privilegeResolvers[permission]();
  }

  private async isAdmin(): Promise<boolean> {
    // this method should only be called internally to determine permissions based on admin role
    // roles should never be checked publicly, only permissions/privileges
    const session = await fetchAuthSession();

    if (!session.tokens?.accessToken) {
      return false;
    }

    const userGroups: string[] = (session.tokens.accessToken.payload['cognito:groups'] as string[]) || [];

    return userGroups.includes('Admins');
  }
}
